import {
  SET_REPORTS_PURCHASES,
  SET_REPORTS_PURCHASES_TABLE,
  SET_REPORTS_FINANCE_SUMMARY,
  SET_REPORTS_RECEIVABLES,
  SET_REPORTS_RECEIVABLES_TABLE,
  SET_REPORTS_PAYABLES,
  SET_REPORTS_PAYABLES_TABLE,
  SET_REPORTS_SALES,
  SET_REPORTS_SALES_TABLE,
  SET_REPORTS_LOADING,
  SET_REPORTS_TABLE_LOADING,
  SET_REPORTS_ERROR,
} from "../../actions/reportAction";

var initialState = {
  purchases: null,
  sales: null,
  financeSummary: null,
  receivables: null,
  payables: null,
  purchasesTable: null,
  salesTable: null,
  receivablesTable: null,
  payablesTable: null,
  loading: false,
  tableLoading: false,
  error: null,
};

const reportReducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case SET_REPORTS_PURCHASES:
      return {
        ...state,
        purchases: action.data,
        error: null,
      };

    case SET_REPORTS_SALES:
      return {
        ...state,
        sales: action.data,
        error: null,
      };

    case SET_REPORTS_FINANCE_SUMMARY:
      return {
        ...state,
        financeSummary: action.data,
        error: null,
      };

    case SET_REPORTS_RECEIVABLES:
      return {
        ...state,
        receivables: action.data,
        error: null,
      };

    case SET_REPORTS_PAYABLES:
      return {
        ...state,
        payables: action.data,
        error: null,
      };

    case SET_REPORTS_PURCHASES_TABLE:
      return {
        ...state,
        purchasesTable: action.data,
        error: null,
      };

    case SET_REPORTS_SALES_TABLE:
      return {
        ...state,
        salesTable: action.data,
        error: null,
      };

    case SET_REPORTS_RECEIVABLES_TABLE:
      return {
        ...state,
        receivablesTable: action.data,
        error: null,
      };

    case SET_REPORTS_PAYABLES_TABLE:
      return {
        ...state,
        payablesTable: action.data,
        error: null,
      };

    case SET_REPORTS_ERROR:
      return {
        ...state,
        loading: false,
        tableLoading: false,
        error: action.error,
      };
    case SET_REPORTS_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    case SET_REPORTS_TABLE_LOADING:
      return {
        ...state,
        tableLoading: action.status,
      };
    default:
      return state;
  }
};

export default reportReducer;
